import axios from "axios";
import {
  SalesReportQueryDto,
  SalesReportResult,
  SalesStatsResult,
} from "../dto/reports.dto";
import { BACKEND_URL } from "../utils/constants";

export const getSalesReport = async ({
  page = 10,
  limit = 1,
  ...params
}: SalesReportQueryDto) => {
  return axios
    .get<SalesReportResult>(`${BACKEND_URL}/reports/sales-report`, {
      params: {
        page,
        limit,
        ...params,
      },
      paramsSerializer: {
        indexes: null,
      },
    })
    .then((res) => res.data);
};

export const getSalesStats = async (
  params: Omit<SalesReportQueryDto, "limit" | "page">,
) => {
  return axios
    .get<SalesStatsResult>(`${BACKEND_URL}/reports/sales/stats`, {
      params,
      paramsSerializer: {
        indexes: null,
      },
    })
    .then((res) => res.data);
};

export const exportSalesReport = async (
  params: Omit<SalesReportQueryDto, "limit" | "page">,
): Promise<void> => {
  const response = await axios.post(
    `${BACKEND_URL}/reports/export-excel`,
    { ...params, reportType: "sales-report" },
    {
      responseType: "blob",
    },
  );

  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = url;

  const contentDisposition = response.headers["content-disposition"];
  let fileName = `sales_report_${params.startDate}_to_${params.endDate}.xlsx`;
  if (contentDisposition) {
    const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
    if (fileNameMatch && fileNameMatch.length === 2)
      fileName = fileNameMatch[1];
  }

  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  link.remove();
};
